import React, { useState, useEffect } from "react";
import ellipse152 from "../../assets/images/ellipse152.png";
import ellipse153 from "../../assets/images/ellipse153.png";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Select,
  Layout,
  Checkbox,
  TreeSelect,
  Button,
  Table,
  Radio,
  Modal,
} from "antd";
import "antd/dist/antd.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import CheckAuthorization from "../../utilities/auth/checkAuthorization";
import Loader from "../../components/loader";
import Wrapper from "../../components/wrapper";
import Bookmarks from "../../components/bookmark/bookmarks";
import CustomAxios, {
  CustomAxiosDE,
} from "../../utilities/service/api.service";
import axios from 'axios';
import {
  getEposFilters,
  setEposFilters,
  setEposTableLoading,
  setEposDataFilters,
  seteposTimeframeCheckbox,
  seteposcolumnSelectionCheckbox,
  setincludeAllCheckboxEpos,
  setEposTableDataPreview,
  setEposTableDataPreviewColumns,
  setEposTimeHorizonRadio,
  getEposKPIs,
  setTimeSelectedfromDynamicWeekly,
  setDatasetEpos,
  setEposYear,
  setEposYearPeriod,
  setEposYearPeriodWeek,
  setEposExportDataLoading,
  setEposExportData,
  setLoadingEpos,
} from "../../slicers/eposfilters.slicer";
import { API } from "../../utilities/constants";
import { getEposBookmarks } from "../../slicers/bookmarks.slicer";
import { showErrorMessage } from "../../utilities/helperFns";
import smallerblock from "../../assets/images/smallerblock.png";
import largerblock from "../../assets/images/largerblock.png";
import envelope from "../../assets/images/envelope.png";
import "../styling/epos.scss";

const { Content } = Layout;
const { SHOW_PARENT } = TreeSelect;
const EposPage = (props) => {
  const { loading } = useSelector((state) => state.datasets);
  const [applyError, setApplyError] = useState(false);
  const [eposPage, setEposPage] = useState('')
  const dispatch = useDispatch();
  const { email_home } = useSelector((state) => state.hometab);
  const {
    eposdropdownLoading,
    filters_epos,
    data_filters_epos,
    customer_market,
    customer_channel,
    customer_retail,
    product_animal_type,
    product_segment,
    product_manufacturer,
    product_brand,
    eposincludeAllCheckbox,
    timeHorizonRadioEpos,
    kpis,
    periodicity,
    eposYear,
    eposYearPeriod,
    eposYearPeriodWeek,
    epostimeframeCheckbox,
    timeSelection_calendar,
    eposcolumnSelectionCheckbox,
    dataset_selected_epos,
    epostabledataPreview,
    epostabledataPreviewColumns,
    epostableLoading,
    previewFormatEpos,
    epos_dataset_selected,
    timeSelection_dynamic_weekly,
  } = useSelector((state) => state.eposfilters);
  const includeAllLevels = [
    "customer_id__market",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__segment",
    "product_id__manufacturer",
    "product_id__brand",
  ];
  const includeAllLevelsonLoad = [
    "customer_id__market",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__segment",
    "product_id__manufacturer",
    "product_id__brand",
  ];
  const includeNoLevel = [];
  const reset_filters = {
    customer_retail: [],
    customer_channel: [],
    customer_market: [],
    kpis: [],
    product_manufacturer: [],
    product_brand: [],
    product_segment: [],
    product_animal_type: [],
    periodicity: [],
  };
  //for updating the dataset, filters data, bookmarks on page load
  useEffect(() => {
    dispatch(setDatasetEpos("epos"));
    dispatch(getEposFilters());
    dispatch(getEposKPIs());
    dispatch(setincludeAllCheckboxEpos(["include_all_levels"]));
    dispatch(getEposBookmarks(epos_dataset_selected));
    handleTabClick();

  }, []);

  const handleTabClick = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get(API.epos_kpis_page, config)
      setEposPage(response)
    } catch (error) {
      console.error(error);
    }
  };


  const [timePeriod, setTimePeriod] = useState([]);
  const [, setTimeSelected] = useState([]);
  const [eposloadingModal, setEposLoadingModal] = useState(false);
  const [, setEposLoadingPreviewModal] = useState(false);
  const [openEposExportModal, setOpenEposExportModal] = useState(false);
  const [openEposPreviewModal, setOpenEposPreviewModal] = useState(false);
  const [eposbookmarkModalOn, setEposBookmarkModalOn] = useState(false);
  const [eposExportLoading, setEposExportLoading] = useState(false);
  //below two functions are for export modal
  const handleOk = () => {
    setEposLoadingModal(true);
    setTimeout(() => {
      setEposLoadingModal(false);
      setOpenEposExportModal(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpenEposExportModal(false);
  };
  //export button main function
  const handleExport = () => {
    {
      timeHorizonRadioEpos === "rolledup"
        ? dispatch(
          geteposDataDownloadRolledUp(
            filters_epos,
            kpis,
            periodicity,
            epostimeframeCheckbox,
            eposcolumnSelectionCheckbox,
            dataset_selected_epos,
            timeHorizonRadioEpos
          )
        )
        : dispatch(
          geteposDataDownloadDynamicWeekly(
            filters_epos,
            kpis,
            eposYear,
            eposYearPeriod,
            eposYearPeriodWeek,
            epostimeframeCheckbox,
            eposcolumnSelectionCheckbox,
            dataset_selected_epos,
            timeHorizonRadioEpos
          )
        );
    }
    setApplyError(false);
    setOpenEposPreviewModal(false);
  };
  //below two functions are for preview modal
  const handleOkPreview = () => {
    setEposLoadingPreviewModal(true);
    setTimeout(() => {
      setEposLoadingPreviewModal(false);
      setOpenEposPreviewModal(false);
    }, 3000);
  };
  const handleCancelPreview = () => {
    setOpenEposPreviewModal(false);
  };
  //function for updating the periodicity filter after selecting values from dropdowns
  const onPeriodicitySelection = (key, value) => {
    let newFilters = {
      ...filters_epos,
      [key]: value,
    };
    dispatch(setEposFilters(newFilters));
  };
  //function for updating the filters after selecting values from dropdowns
  const onSelection = (key, value) => {
    let newFilters = {
      ...filters_epos,
      [key]: value,
    };

    dispatch(setEposFilters(newFilters));
    dispatch(setEposDataFilters(newFilters));
  };
  //function for updating single select market filter
  const onMarketSingleSelect = (val) => {
    let newFiltersSelected = {
      ...filters_epos,
      ["customer_market"]: [val],
    };
    dispatch(setEposFilters(newFiltersSelected));
    dispatch(setEposDataFilters(newFiltersSelected));
  };
  //functions for handling the dropdowns after clearing selected options
  const handleOnClear = (key, value) => {
    let newEposFilters = {
      ...filters_epos,
      [key]: value,
    };

    dispatch(setEposFilters(newEposFilters));
    dispatch(setEposDataFilters(newEposFilters));
    dispatch(getEposFilters(newEposFilters));
  };
  const handleOnClearSingleMarket = () => {
    let newFilterSelected = {
      customer_market: [],
    };
    dispatch(setEposFilters(newFilterSelected));
    dispatch(setEposDataFilters(newFilterSelected));
    dispatch(getEposFilters(newFilterSelected));
  };
  //main function for reset
  const handleReset = () => {
    dispatch(setEposFilters(reset_filters));
    dispatch(getEposFilters(reset_filters));
    dispatch(seteposTimeframeCheckbox([]));
    dispatch(seteposcolumnSelectionCheckbox(includeAllLevelsonLoad));
    dispatch(setincludeAllCheckboxEpos("include_all_levels"));
    dispatch(setEposTableDataPreview([]));
    dispatch(setEposTableDataPreviewColumns([]));
    dispatch(setTimeSelectedfromDynamicWeekly([]));
  };
  //function for updating the Calendar - Time Selection filter after selecting values from dropdown (in dynamic weekly scenario)
  const onSelectingTimePeriod = (value) => {
    let newTimePeriod = value;
    let yearSelection = [];
    let yearPeriodSelection = [];
    let yearPeriodWeekSelection = [];
    let year_only = value.filter(
      (val) => val.includes("P") === false && val.includes("W") === false
    );
    yearSelection = year_only;
    let period_values = value.filter(
      (val) => val.includes("P") === true && val.includes("W") === false
    );
    yearPeriodSelection = period_values;
    let period_week_values = value.filter(
      (val) => val.includes("P") === true && val.includes("W") === true
    );
    yearPeriodWeekSelection = period_week_values;
    setTimeSelected(newTimePeriod);
    dispatch(setTimeSelectedfromDynamicWeekly(newTimePeriod));
    dispatch(setEposYear(yearSelection));
    dispatch(setEposYearPeriod(yearPeriodSelection));
    dispatch(setEposYearPeriodWeek(yearPeriodWeekSelection));
  };
  //functions for bookmark modal
  const openBookmarkModal = () => {
    setEposBookmarkModalOn(true);
    dispatch(getEposBookmarks(epos_dataset_selected));
  };
  const handleOkBookmarkModal = () => {
    setEposBookmarkModalOn(false);
  };
  const handleCancelBookmarkModal = () => {
    setEposBookmarkModalOn(false);
  };
  //function for updating time frames checkboxes - Include YA, Include 2YA
  const timeframeSelection = () => (e) => {
    if (e.target.checked) {
      let value = [...epostimeframeCheckbox];
      value.push(e.target.value);
      dispatch(seteposTimeframeCheckbox(value));
    } else {
      let value = [...epostimeframeCheckbox];
      value = value.filter((val) => val !== e.target.value);
      dispatch(seteposTimeframeCheckbox(value));
    }
  };
  //function for maintaining selected columns in the eposcolumnSelectionCheckbox array
  const columns_Selection = () => (e) => {
    if (e.target.checked) {
      let value = [...eposcolumnSelectionCheckbox];
      value.push(e.target.value);
      dispatch(seteposcolumnSelectionCheckbox(value)) &&
        eposcolumnSelectionCheckbox.length === includeAllLevels.length - 1
        ? dispatch(setincludeAllCheckboxEpos(["include_all_levels"]))
        : dispatch(setincludeAllCheckboxEpos([""]));
    } else {
      let value = [...eposcolumnSelectionCheckbox];
      value = value.filter((val) => val !== e.target.value);
      dispatch(seteposcolumnSelectionCheckbox(value));
      dispatch(setincludeAllCheckboxEpos([""]));
    }
  };
  //function for updating Include All checkbox
  const include_all_Selection = () => (e) => {
    if (e.target.checked) {
      dispatch(setincludeAllCheckboxEpos(["include_all_levels"]));
      dispatch(seteposcolumnSelectionCheckbox(includeAllLevels));
    } else {
      dispatch(setincludeAllCheckboxEpos([""]));
      dispatch(seteposcolumnSelectionCheckbox(includeNoLevel));
    }
  };
  //function for updating radio selection for rolled-up/dynamic weekly
  const timeHorizonRadioSelection = () => (e) => {
    if (e.target.checked) {
      dispatch(setEposTimeHorizonRadio(e.target.value));
    }
  };
  //for preparing data in Calendar - Time Selection filter in dynamic weekly scenario
  useEffect(() => {
    if (
      timeSelection_calendar &&
      Object.keys(timeSelection_calendar).length > 0
    ) {
      let weekperiodYear = timeSelection_calendar;
      setTimePeriod(
        Object.keys(weekperiodYear).map((year) => ({
          title: year,
          value: year,
          key: year,
          children: year
            ? Object.keys(weekperiodYear[year]).map((period) => ({
              title: `${year} ${period}`,
              value: `${year} ${period}`,
              key: period,
              children: period
                ? weekperiodYear[year][period].map((week) => ({
                  title: `${year} ${period} ${week}`,
                  value: `${year} ${period} ${week}`,
                  key: week,
                }))
                : [],
            }))
            : [],
        }))
      );
    }
  }, [timeSelection_calendar]);
  //function for obtaining preview in rolled-up state
  const getTableDataPreviewRolledUp =
    (
      filters_epos,
      kpis,
      periodicityRolledup,
      epostimeframeCheckbox,
      eposcolumnSelectionCheckbox,
      dataset_selected_epos,
      timeHorizonRadioEpos,
      previewFormatEpos
    ) =>
      async (dispatch, getState) => {
        let kpis = [];
        let periodicityRolledup = filters_epos.periodicity;
        let new_Filters = { ...filters_epos };
        kpis = filters_epos.kpis;
        if (
          typeof periodicityRolledup !== "undefined" &&
          periodicityRolledup.length > 0
        ) {
          periodicityRolledup = filters_epos.periodicity;
        } else {
          periodicityRolledup = data_filters_epos.periodicity;
        }
        let newFilters = { ...new_Filters };

        // Remove Empty Key Value Pairs
        Object.keys(newFilters).forEach((key) => {
          if (newFilters[key].length === 0) {
            delete newFilters[key];
          }
        });
        const asArrayflatten = Object.entries(newFilters);
        const groupArray = [];
        var i;
        for (i = 0; i < Object.keys(newFilters).length; i++) {
          groupArray.push([
            Object.values(asArrayflatten)[i][0],
            Object.values(asArrayflatten)[i][1].filter((val) => val !== "ALL"),
          ]);
        }
        const payloadFiltersArray = [];
        var j;
        for (j = 0; j < Object.keys(groupArray).length; j++) {
          if (groupArray[j][1].length > 0) {
            payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
          }
        }
        const payloadFilters = Object.fromEntries(payloadFiltersArray);
        let column_filters = payloadFilters;
        let kpi_combination = payloadFilters.kpis;
        let periodicity = periodicityRolledup;
        let time_frames = epostimeframeCheckbox;
        let column_selection = eposcolumnSelectionCheckbox;
        let dataset = dataset_selected_epos;
        let timeHorizon = timeHorizonRadioEpos;
        let preview_format = previewFormatEpos;
        dispatch(setEposTableLoading(true));
        CustomAxios(API.table_preview, "POST", {
          column_filters,
          kpi_combination,
          periodicity,
          time_frames,
          column_selection,
          dataset,
          timeHorizon,
          preview_format,
        })
          .then((response) => {
            if (response?.status === 200) {
              dispatch(setEposTableDataPreview(response.data.preview_data));
              let columns = Object.keys(response.data.preview_data[0]).map(
                (val) => {
                  return {
                    title: val.split("_").join(" ").toUpperCase(),
                    dataIndex: val,
                    width: val.length * 5,
                  };
                }
              );
              dispatch(setEposTableDataPreviewColumns(columns));
              dispatch(setEposTableLoading(false));
            } else {
              showErrorMessage();
            }
          })
          .catch((err) => {
            if (err.status === 403) {
              CheckAuthorization();
            }
            setOpenEposPreviewModal(true);
            console.error("Data Preview Refresh failed", err);
            dispatch(
              getTableDataPreviewRolledUp(
                column_filters,
                kpi_combination,
                periodicity,
                time_frames,
                column_selection,
                dataset,
                timeHorizon,
                (preview_format = true)
              )
            );
            dispatch(setEposTableLoading(false));
          });
      };
  //function for obtaining preview in dynamic weekly state
  const getTableDataPreviewDynamicWeekly =
    (
      filters_epos,
      kpis,
      eposYear,
      eposYearPeriod,
      eposYearPeriodWeek,
      epostimeframeCheckbox,
      eposcolumnSelectionCheckbox,
      dataset_selected_epos,
      timeHorizonRadioEpos,
      previewFormatEpos
    ) =>
      async (dispatch, getState) => {
        const filteredObject = Object.fromEntries(
          Object.entries(filters_epos).filter(
            ([key, value]) => key !== "periodicity"
          )
        );
        let newFilters = { ...filteredObject };

        // Remove Empty Key Value Pairs
        Object.keys(newFilters).forEach((key) => {
          if (newFilters[key].length === 0) {
            delete newFilters[key];
          }
        });
        const asArrayflatten = Object.entries(newFilters);
        const groupArray = [];
        var i;
        for (i = 0; i < Object.keys(newFilters).length; i++) {
          groupArray.push([
            Object.values(asArrayflatten)[i][0],
            Object.values(asArrayflatten)[i][1].filter((val) => val !== "ALL"),
          ]);
        }
        const payloadFiltersArray = [];
        var j;
        for (j = 0; j < Object.keys(groupArray).length; j++) {
          if (groupArray[j][1].length > 0) {
            payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
          }
        }
        const payloadFilters = Object.fromEntries(payloadFiltersArray);
        let column_filters = payloadFilters;
        let kpi_combination = payloadFilters.kpis;
        let year = eposYear;
        let yearPeriod = eposYearPeriod;
        let yearPeriodWeek = eposYearPeriodWeek;
        let time_frames = epostimeframeCheckbox;
        let column_selection = eposcolumnSelectionCheckbox;
        let dataset = dataset_selected_epos;
        let timeHorizon = timeHorizonRadioEpos;
        let preview_format = previewFormatEpos;
        dispatch(setEposTableLoading(true));
        CustomAxios(API.table_preview, "POST", {
          column_filters,
          kpi_combination,
          year,
          yearPeriod,
          yearPeriodWeek,
          time_frames,
          column_selection,
          dataset,
          timeHorizon,
          preview_format,
        })
          .then((response) => {
            if (response?.status === 200) {
              dispatch(setEposTableDataPreview(response.data.preview_data));
              let columns = Object.keys(response.data.preview_data[0]).map(
                (val) => {
                  return {
                    title: val.split("_").join(" ").toUpperCase(),
                    dataIndex: val,
                    width: val.length * 5,
                  };
                }
              );
              dispatch(setEposTableDataPreviewColumns(columns));
              dispatch(setEposTableLoading(false));
            } else {
              showErrorMessage();
            }
          })
          .catch((err) => {
            if (err.status === 403) {
              CheckAuthorization();
            }
            setOpenEposPreviewModal(true);
            console.error("Data Preview Refresh failed", err);
            dispatch(
              getTableDataPreviewDynamicWeekly(
                column_filters,
                kpi_combination,
                year,
                yearPeriod,
                yearPeriodWeek,
                time_frames,
                column_selection,
                dataset,
                timeHorizon,
                (preview_format = true)
              )
            );
            dispatch(setEposTableLoading(false));
          });
      };
  //function for getting data download in rolled-up state
  const geteposDataDownloadRolledUp =
    (
      filters_epos,
      kpis,
      periodicityDownload,
      epostimeframeCheckbox,
      eposcolumnSelectionCheckbox,
      dataset_selected_epos,
      timeHorizonRadioEpos
    ) =>
      async (dispatch, getState) => {
        let kpis = [];
        let periodicityDownload = filters_epos.periodicity;
        dispatch(setLoadingEpos(true));
        let new_Filters = { ...filters_epos };
        kpis = filters_epos.kpis;
        if (
          typeof periodicityDownload !== "undefined" &&
          periodicityDownload.length > 0
        ) {
          periodicityDownload = filters_epos.periodicity;
        } else {
          periodicityDownload = data_filters_epos.periodicity;
        }
        let newFilters = { ...new_Filters };

        Object.keys(newFilters).forEach((key) => {
          if (newFilters[key].length === 0) {
            delete newFilters[key];
          }
        });
        const asArrayflatten = Object.entries(newFilters);
        const groupArray = [];
        var i;
        for (i = 0; i < Object.keys(newFilters).length; i++) {
          groupArray.push([
            Object.values(asArrayflatten)[i][0],
            Object.values(asArrayflatten)[i][1].filter((val) => val !== "ALL"),
          ]);
        }
        const payloadFiltersArray = [];
        var j;
        for (j = 0; j < Object.keys(groupArray).length; j++) {
          if (groupArray[j][1].length > 0) {
            payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
          }
        }
        const payloadFilters = Object.fromEntries(payloadFiltersArray);
        let column_filters = payloadFilters;
        let kpi_combination = payloadFilters.kpis;
        let periodicity = periodicityDownload;
        let time_frames = epostimeframeCheckbox;
        let column_selection = eposcolumnSelectionCheckbox;
        let dataset = dataset_selected_epos;
        let timeHorizon = timeHorizonRadioEpos;
        setEposExportLoading(true);
        dispatch(setEposExportDataLoading(true));
        CustomAxiosDE(API.export_data, "POST", {
          column_filters,
          kpi_combination,
          periodicity,
          time_frames,
          column_selection,
          dataset,
          timeHorizon,
        })
          .then((response) => {
            if (response?.status === 200) {
              setOpenEposExportModal(true);
              const export_data = response.data.preview_data;
              setEposExportLoading(false);
              dispatch(setEposExportData(export_data));
              dispatch(setEposExportDataLoading(false));
            } else {
              showErrorMessage();
            }
          })
          .catch((err) => {
            if (err.status === 403) {
              CheckAuthorization();
            }
            console.error("error, Error initiating download in epos page", err);
            showErrorMessage();
            setEposExportLoading(false);
            dispatch(setEposExportDataLoading(false));
          });
      };
  //function for getting data download in dynamic weekly state
  const geteposDataDownloadDynamicWeekly =
    (
      filters_epos,
      kpis,
      eposYear,
      eposYearPeriod,
      eposYearPeriodWeek,
      epostimeframeCheckbox,
      eposcolumnSelectionCheckbox,
      dataset_selected_epos,
      timeHorizonRadioEpos
    ) =>
      async (dispatch, getState) => {
        dispatch(setLoadingEpos(true));
        const filteredObject = Object.fromEntries(
          Object.entries(filters_epos).filter(
            ([key, value]) => key !== "periodicity"
          )
        );
        let newFilters = { ...filteredObject };
        Object.keys(newFilters).forEach((key) => {
          if (newFilters[key].length === 0) {
            delete newFilters[key];
          }
        });
        const asArrayflatten = Object.entries(newFilters);
        const groupArray = [];
        var i;
        for (i = 0; i < Object.keys(newFilters).length; i++) {
          groupArray.push([
            Object.values(asArrayflatten)[i][0],
            Object.values(asArrayflatten)[i][1].filter((val) => val !== "ALL"),
          ]);
        }
        const payloadFiltersArray = [];
        var j;
        for (j = 0; j < Object.keys(groupArray).length; j++) {
          if (groupArray[j][1].length > 0) {
            payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
          }
        }
        const payloadFilters = Object.fromEntries(payloadFiltersArray);
        let column_filters = payloadFilters;
        let kpi_combination = payloadFilters.kpis;
        let year = eposYear;
        let yearPeriod = eposYearPeriod;
        let yearPeriodWeek = eposYearPeriodWeek;
        let time_frames = epostimeframeCheckbox;
        let column_selection = eposcolumnSelectionCheckbox;
        let dataset = dataset_selected_epos;
        let timeHorizon = timeHorizonRadioEpos;
        setEposExportLoading(true);
        dispatch(setEposExportDataLoading(true));
        CustomAxiosDE(API.export_data, "POST", {
          column_filters,
          kpi_combination,
          year,
          yearPeriod,
          yearPeriodWeek,
          time_frames,
          column_selection,
          dataset,
          timeHorizon,
        })
          .then((response) => {
            if (response?.status === 200) {
              setOpenEposExportModal(true);
              const export_data = response.data.preview_data;
              setEposExportLoading(false);
              dispatch(setEposExportData(export_data));
              dispatch(setEposExportDataLoading(false));
            } else {
              showErrorMessage();
            }
          })
          .catch((err) => {
            if (err.status === 403) {
              CheckAuthorization();
            }
            console.error("error, Error initiating download in epos page", err);
            showErrorMessage();
            setEposExportLoading(false);
            dispatch(setEposExportDataLoading(false));
          });
      };
  return (
    <Wrapper heading={"4"} innerHeading={"10"}>
      <Content className="content-body-epos">
        <Loader loading={loading > 0} tip={"Please wait.."}>
          <Row gutter={20} wrap={false} className="export-row-width">
            <Col span={24}>
              <Loader
                loading={eposdropdownLoading > 0}
                tip="Please wait while export filters are loaded.."
              >
                <div className="epos-page">
                  <Row className="header-row-contents">
                    <h3>EPOS Data Download</h3>
                    <span className="right-filter">
                      Include All level in Data
                    </span>
                    <Checkbox
                      className="include-all-checkbox"
                      value={"include_all_levels"}
                      checked={
                        !!eposincludeAllCheckbox &&
                        eposincludeAllCheckbox.includes("include_all_levels")
                      }
                      onChange={include_all_Selection()}
                    />
                    <button className="reset-text">Reset</button>
                    <div
                      className="reset-button-components"
                      onClick={() => handleReset()}
                    >
                      <span className="reset-button-1">
                        <img src={ellipse152} />
                      </span>
                      <span className="reset-button-2">
                        <img src={ellipse153} />
                      </span>
                    </div>
                    <button className="bookmark-text">Bookmark</button>
                    <div
                      className="bookmark-component"
                      onClick={() => openBookmarkModal()}
                    >
                      <span className="smaller-block">
                        <img src={smallerblock} />
                      </span>
                      <span className="larger-block">
                        <img src={largerblock} />
                      </span>
                    </div>
                    <Modal
                      title="Personal Bookmarks"
                      bodyStyle={{ height: "fit-content" }}
                      className="nielsen-bookmark-modal"
                      visible={eposbookmarkModalOn}
                      onOk={handleOkBookmarkModal}
                      onCancel={handleCancelBookmarkModal}
                      footer={null}
                    >
                      <Bookmarks
                        bookmarkOn={eposbookmarkModalOn}
                        hideBookmark={() => setEposBookmarkModalOn(false)}
                        dataset={"epos"}
                      />
                    </Modal>
                    <ToastContainer />
                  </Row>
                  <Row className="filters-sections">
                    <Col md={12}>
                      <span className="solid-background"></span>
                      <h5>
                        Time Horizon
                        <div
                          style={{ display: "inline-flex", marginLeft: 150 }}
                        >
                          <Radio
                            style={{ color: "#0000a0" }}
                            value={"rolledup"}
                            checked={
                              !!timeHorizonRadioEpos &&
                              timeHorizonRadioEpos.includes("rolledup")
                            }
                            onChange={timeHorizonRadioSelection()}
                          >
                            Rolled-up Level
                          </Radio>
                          <Radio
                            style={{ color: "#0000a0" }}
                            value={"weekly"}
                            checked={
                              !!timeHorizonRadioEpos &&
                              timeHorizonRadioEpos.includes("weekly")
                            }
                            onChange={timeHorizonRadioSelection()}
                          >
                            Dynamic Weekly
                          </Radio>
                        </div>
                      </h5>

                      {timeHorizonRadioEpos === "weekly" ? (
                        <Row
                          gutter={10}
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <Col md={16} style={{ marginTop: 32 }}>
                            <h5>Calendar - Time Selection</h5>
                            <TreeSelect
                              dropdownMatchSelectWidth={false}
                              showSearch={true}
                              placeholder={"All"}
                              multiple
                              treeCheckable={true}
                              showCheckedStrategy={SHOW_PARENT}
                              value={timeSelection_dynamic_weekly}
                              onChange={(value) => onSelectingTimePeriod(value)}
                              style={{ width: "100%", minWidth: 300 }}
                              dropdownStyle={{ minWidth: "20%" }}
                              treeData={timePeriod}
                              allowClear
                            />
                          </Col>
                          <div style={{ marginTop: 20, marginBottom: 32 }}>
                            *Weekly can be downloaded for one market at time
                          </div>
                          <Row
                            style={{
                              marginTop: 60,
                              marginBottom: 32,
                              marginLeft: -322,
                            }}
                          >
                            <Checkbox
                              value={"ya"}
                              checked={
                                !!epostimeframeCheckbox &&
                                epostimeframeCheckbox.includes("ya")
                              }
                              onChange={timeframeSelection()}
                              style={{ marginLeft: 5 }}
                            >
                              Include YA
                            </Checkbox>
                            <Checkbox
                              value={"2ya"}
                              checked={
                                !!epostimeframeCheckbox &&
                                epostimeframeCheckbox.includes("2ya")
                              }
                              onChange={timeframeSelection()}
                              style={{ marginLeft: 6.262 }}
                            >
                              Include 2YA
                            </Checkbox>
                          </Row>
                        </Row>
                      ) : (
                        <Row
                          gutter={10}
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <Col md={8} className="dropdown-card">
                            <label
                              className="label-block-epos"
                              style={{ marginTop: "5px", marginLeft: "29px" }}
                            >
                              Select Rolled-up{" "}
                            </label>
                            <Select
                              dropdownMatchSelectWidth={false}
                              value={filters_epos.periodicity}
                              onChange={(val) =>
                                onPeriodicitySelection("periodicity", val)
                              }
                              onClear={() =>
                                handleOnClear(
                                  "periodicity",
                                  data_filters_epos.periodicity
                                )
                              }
                              placeholder="All"
                              mode="multiple"
                              maxTagCount="responsive"
                              placement="bottomLeft"
                              allowClear
                              bordered={true}
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              {periodicity?.map((val) => (
                                <Select.Option value={val}>{val}</Select.Option>
                              ))}
                            </Select>
                          </Col>
                          <Checkbox
                            value={"ya"}
                            checked={
                              !!epostimeframeCheckbox &&
                              epostimeframeCheckbox.includes("ya")
                            }
                            onChange={timeframeSelection()}
                            style={{ marginLeft: 200, marginTop: 31.5 }}
                          >
                            Include YA
                          </Checkbox>
                          <Checkbox
                            value={"2ya"}
                            checked={
                              !!epostimeframeCheckbox &&
                              epostimeframeCheckbox.includes("2ya")
                            }
                            onChange={timeframeSelection()}
                            style={{ marginLeft: 6.26, marginTop: 31.5 }}
                          >
                            Include 2YA
                          </Checkbox>
                          <div style={{ marginTop: 20, marginBottom: 32 }}>
                            *Roll up data is available for as of date only{" "}
                          </div>
                        </Row>
                      )}

                      <span className="solid-background"></span>
                      <h5>Market and Customer Details</h5>
                      <Row
                        gutter={10}
                        style={{ marginTop: 10, marginBottom: 10 }}
                      >
                        <Col
                          md={8}
                          className="dropdown-card"
                          style={{ marginTop: 10 }}
                        >
                          <Checkbox
                            defaultChecked={true}
                            value={"customer_id__market"}
                            checked={
                              !!eposcolumnSelectionCheckbox &&
                              eposcolumnSelectionCheckbox.includes(
                                "customer_id__market"
                              )
                            }
                            onChange={columns_Selection()}
                            style={{ marginTop: "5px" }}
                          >
                            {<label className="label-block-epos">Market</label>}
                          </Checkbox>
                          {timeHorizonRadioEpos !== "weekly" ? (
                            <Select
                              defaultActiveFirstOption={true}
                              dropdownMatchSelectWidth={false}
                              value={filters_epos.customer_market}
                              onChange={(val) =>
                                onSelection("customer_market", val)
                              }
                              onBlur={() =>
                                dispatch(getEposFilters(filters_epos))
                              }
                              onClear={() =>
                                handleOnClear("customer_market", [])
                              }
                              placeholder="All"
                              mode="multiple"
                              maxTagCount="responsive"
                              placement="bottomLeft"
                              allowClear
                              bordered={true}
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              {customer_market?.map((val) => (
                                <Select.Option value={val}>{val}</Select.Option>
                              ))}
                            </Select>
                          ) : (
                            <>
                              <Select
                                dropdownMatchSelectWidth={false}
                                value={filters_epos.customer_market}
                                onChange={(val) => {
                                  if (val) {
                                    onMarketSingleSelect(val);
                                  }
                                }}
                                onBlur={() =>
                                  dispatch(getEposFilters(filters_epos))
                                }
                                onClear={handleOnClearSingleMarket}
                                placeholder="Select Market"
                                mode="single"
                                maxTagCount="responsive"
                                placement="bottomLeft"
                                allowClear
                                bordered={true}
                                style={{ width: "100%", marginTop: "10px" }}
                              >
                                {customer_market?.map((val) => {
                                  if (val !== "ALL")
                                    return (
                                      <Select.Option value={val}>
                                        {val}
                                      </Select.Option>
                                    );
                                })}
                              </Select>
                              <Row style={{ marginTop: 10 }}>
                                {applyError ? (
                                  <p style={{ color: "red" }}>
                                    Market selection is mandatory for Dynamic
                                    Weekly
                                  </p>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </>
                          )}
                        </Col>
                        <Col
                          md={8}
                          className="dropdown-card"
                          style={{ marginTop: 10 }}
                        >
                          <Checkbox
                            defaultChecked={true}
                            value={"customer_id__channel"}
                            checked={
                              !!eposcolumnSelectionCheckbox &&
                              eposcolumnSelectionCheckbox.includes(
                                "customer_id__channel"
                              )
                            }
                            onChange={columns_Selection()}
                            style={{ marginTop: "5px" }}
                          >
                            {
                              <label className="label-block-epos">
                                Channel
                              </label>
                            }
                          </Checkbox>
                          <Select
                            dropdownMatchSelectWidth={false}
                            placeholder="All"
                            mode="multiple"
                            value={filters_epos.customer_channel}
                            onChange={(val) =>
                              onSelection("customer_channel", val)
                            }
                            onBlur={() =>
                              dispatch(getEposFilters(filters_epos))
                            }
                            onClear={() =>
                              handleOnClear("customer_channel", [])
                            }
                            allowClear
                            bordered={true}
                            maxTagCount="responsive"
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            {customer_channel?.map((val) => (
                              <Select.Option value={val}>{val}</Select.Option>
                            ))}
                          </Select>
                        </Col>
                        <Col
                          md={8}
                          className="dropdown-card"
                          style={{ marginTop: 10 }}
                        >
                          <Checkbox
                            value={"customer_id__retailer"}
                            checked={
                              !!eposcolumnSelectionCheckbox &&
                              eposcolumnSelectionCheckbox.includes(
                                "customer_id__retailer"
                              )
                            }
                            onChange={columns_Selection()}
                            style={{ marginTop: "5px" }}
                          >
                            {
                              <label className="label-block-epos">
                                Retailer
                              </label>
                            }
                          </Checkbox>
                          <Select
                            dropdownMatchSelectWidth={false}
                            placeholder="All"
                            mode="multiple"
                            value={filters_epos.customer_retail}
                            onChange={(val) =>
                              onSelection("customer_retail", val)
                            }
                            onBlur={() =>
                              dispatch(getEposFilters(filters_epos))
                            }
                            onClear={() => handleOnClear("customer_retail", [])}
                            allowClear
                            bordered={true}
                            maxTagCount="responsive"
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            {customer_retail?.map((val) => (
                              <Select.Option value={val}>{val}</Select.Option>
                            ))}
                          </Select>
                        </Col>
                        <Col md={24} style={{ marginTop: 32 }}>
                          <span className="solid-background"></span>
                          <h5>KPI</h5>
                          <Row gutter={10} style={{ marginTop: 15 }}>
                            <Col md={8} className="dropdown-card">
                              <label className="label-block-epos">KPI</label>
                              <Select
                                dropdownMatchSelectWidth={false}
                                placeholder="All"
                                mode="multiple"
                                value={filters_epos.kpis}
                                onChange={(val) => onSelection("kpis", val)}
                                allowClear
                                maxTagCount="responsive"
                                style={{ width: "100%" }}
                              >
                                {kpis?.map((val) => (
                                  <Select.Option value={val}>
                                    {val}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={2}></Col>
                    <Col md={10}>
                      <span className="solid-background"></span>
                      <h5>Product Details</h5>
                      <Row
                        gutter={10}
                        style={{ marginTop: 10, marginBottom: 10 }}
                      >
                        <Col
                          md={8}
                          className="dropdown-card"
                          style={{ marginTop: 10 }}
                        >
                          <Checkbox
                            defaultChecked={true}
                            value={"product_id__animal_type"}
                            checked={
                              !!eposcolumnSelectionCheckbox &&
                              eposcolumnSelectionCheckbox.includes(
                                "product_id__animal_type"
                              )
                            }
                            onChange={columns_Selection()}
                            style={{ marginTop: "5px" }}
                          >
                            {<label className="label-block-epos">Pet</label>}
                          </Checkbox>
                          <Select
                            dropdownMatchSelectWidth={false}
                            placeholder="All"
                            mode="multiple"
                            value={filters_epos.product_animal_type}
                            onChange={(val) =>
                              onSelection("product_animal_type", val)
                            }
                            onBlur={() =>
                              dispatch(getEposFilters(filters_epos))
                            }
                            onClear={() =>
                              handleOnClear("product_animal_type", [])
                            }
                            allowClear
                            bordered={true}
                            maxTagCount="responsive"
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            {product_animal_type?.map((val) => (
                              <Select.Option value={val}>{val}</Select.Option>
                            ))}
                          </Select>
                        </Col>
                        <Col
                          md={8}
                          className="dropdown-card"
                          style={{ marginTop: 10 }}
                        >
                          <Checkbox
                            defaultChecked={true}
                            value={"product_id__segment"}
                            checked={
                              !!eposcolumnSelectionCheckbox &&
                              eposcolumnSelectionCheckbox.includes(
                                "product_id__segment"
                              )
                            }
                            onChange={columns_Selection()}
                            style={{ marginTop: "5px" }}
                          >
                            {
                              <label className="label-block-epos">
                                Portfolio
                              </label>
                            }
                          </Checkbox>
                          <Select
                            dropdownMatchSelectWidth={false}
                            placeholder="All"
                            mode="multiple"
                            value={filters_epos.product_segment}
                            onChange={(val) =>
                              onSelection("product_segment", val)
                            }
                            onBlur={() =>
                              dispatch(getEposFilters(filters_epos))
                            }
                            onClear={() => handleOnClear("product_segment", [])}
                            allowClear
                            bordered={true}
                            maxTagCount="responsive"
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            {product_segment?.map((val) => (
                              <Select.Option value={val}>{val}</Select.Option>
                            ))}
                          </Select>
                        </Col>
                        <Col
                          md={8}
                          className="dropdown-card"
                          style={{ marginTop: 10 }}
                        >
                          <Checkbox
                            defaultChecked={true}
                            value={"product_id__manufacturer"}
                            checked={
                              !!eposcolumnSelectionCheckbox &&
                              eposcolumnSelectionCheckbox.includes(
                                "product_id__manufacturer"
                              )
                            }
                            onChange={columns_Selection()}
                            style={{ marginTop: "5px" }}
                          >
                            {
                              <label className="label-block-epos">
                                Manufacturer
                              </label>
                            }
                          </Checkbox>
                          <Select
                            dropdownMatchSelectWidth={false}
                            placeholder="All"
                            mode="multiple"
                            value={filters_epos.product_manufacturer}
                            onChange={(val) =>
                              onSelection("product_manufacturer", val)
                            }
                            onBlur={() =>
                              dispatch(getEposFilters(filters_epos))
                            }
                            onClear={() =>
                              handleOnClear("product_manufacturer", [])
                            }
                            allowClear
                            bordered={true}
                            maxTagCount="responsive"
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            {product_manufacturer?.map((val) => (
                              <Select.Option value={val}>{val}</Select.Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                      <Row
                        gutter={10}
                        style={{ marginTop: 10, marginBottom: 10 }}
                      >
                        <Col
                          md={8}
                          className="dropdown-card"
                          style={{ marginTop: 6 }}
                        >
                          <Checkbox
                            defaultChecked={true}
                            value={"product_id__brand"}
                            checked={
                              !!eposcolumnSelectionCheckbox &&
                              eposcolumnSelectionCheckbox.includes(
                                "product_id__brand"
                              )
                            }
                            onChange={columns_Selection()}
                            style={{ marginTop: "5px" }}
                          >
                            {<label className="label-block-epos">Brand</label>}
                          </Checkbox>
                          <Select
                            dropdownMatchSelectWidth={false}
                            placeholder="All"
                            mode="multiple"
                            value={filters_epos.product_brand}
                            onChange={(val) =>
                              onSelection("product_brand", val)
                            }
                            onBlur={() =>
                              dispatch(getEposFilters(filters_epos))
                            }
                            onClear={() => handleOnClear("product_brand", [])}
                            allowClear
                            bordered={true}
                            maxTagCount="responsive"
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            {product_brand?.map((val) => (
                              <Select.Option value={val}>{val}</Select.Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <Row
                        gutter={10}
                        style={{
                          marginTop: 10,
                          marginLeft: "980px",
                          display: "inline-flex",
                        }}
                      >
                        <Col
                          md={8}
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          {timeHorizonRadioEpos === "rolledup" ? (
                            <Button
                              type="primary"
                              loading={epostableLoading > 0}
                              onClick={() => {
                                dispatch(
                                  getTableDataPreviewRolledUp(
                                    filters_epos,
                                    kpis,
                                    periodicity,
                                    epostimeframeCheckbox,
                                    eposcolumnSelectionCheckbox,
                                    dataset_selected_epos,
                                    timeHorizonRadioEpos,
                                    previewFormatEpos
                                  )
                                );
                              }}
                            >
                              Load Preview
                            </Button>
                          ) : (
                            <Button
                              type="primary"
                              loading={epostableLoading > 0}
                              onClick={() => {
                                if (filters_epos.customer_market.length !== 0) {
                                  dispatch(
                                    getTableDataPreviewDynamicWeekly(
                                      filters_epos,
                                      kpis,
                                      eposYear,
                                      eposYearPeriod,
                                      eposYearPeriodWeek,
                                      epostimeframeCheckbox,
                                      eposcolumnSelectionCheckbox,
                                      dataset_selected_epos,
                                      timeHorizonRadioEpos,
                                      previewFormatEpos
                                    )
                                  );
                                  setApplyError(false);
                                } else {
                                  setApplyError(true);
                                }
                              }}
                            >
                              Load Preview
                            </Button>
                          )}
                          <Modal
                            visible={openEposPreviewModal}
                            title={<img src={envelope}></img>}
                            onOk={handleOkPreview}
                            onCancel={handleCancelPreview}
                            className="previewModalStyle"
                            footer={[
                              <Button
                                key="submit"
                                type="primary"
                                loading={eposloadingModal}
                                onClick={handleExport}
                              >
                                Export
                              </Button>,
                            ]}
                          >
                            <p>
                              Preview is taking more time than usual due to the
                              large size of the data, we have loaded the
                              structure of output data for you.
                            </p>

                            <p>
                              You can click on Export to get the download link
                            </p>
                          </Modal>
                          <ToastContainer />
                        </Col>
                        <Col md={4}>
                          {timeHorizonRadioEpos === "rolledup" ? (
                            <Button
                              type="primary"
                              loading={eposExportLoading}
                              disabled={eposdropdownLoading > 0}
                              onClick={() => {
                                dispatch(
                                  geteposDataDownloadRolledUp(
                                    filters_epos,
                                    kpis,
                                    periodicity,
                                    epostimeframeCheckbox,
                                    eposcolumnSelectionCheckbox,
                                    dataset_selected_epos,
                                    timeHorizonRadioEpos
                                  )
                                );
                              }}
                            >
                              Export Data
                            </Button>
                          ) : (
                            <Button
                              type="primary"
                              loading={eposExportLoading}
                              disabled={eposdropdownLoading > 0}
                              onClick={() => {
                                if (filters_epos.customer_market.length !== 0) {
                                  dispatch(
                                    geteposDataDownloadDynamicWeekly(
                                      filters_epos,
                                      kpis,
                                      eposYear,
                                      eposYearPeriod,
                                      eposYearPeriodWeek,
                                      epostimeframeCheckbox,
                                      eposcolumnSelectionCheckbox,
                                      dataset_selected_epos,
                                      timeHorizonRadioEpos
                                    )
                                  );
                                } else {
                                  setApplyError(true);
                                }
                              }}
                            >
                              Export Data
                            </Button>
                          )}
                          <Modal
                            visible={openEposExportModal}
                            title={<img src={envelope}></img>}
                            onOk={handleOk}
                            onCancel={handleCancel}
                            className="exportModalStyle"
                            footer={null}
                          >
                            <p>
                              The download will be shared with you on your email
                              ID
                            </p>

                            <p>{email_home} .</p>
                          </Modal>
                          <ToastContainer />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Loader loading={epostableLoading > 0} tip="Loading..">
                    <Row className="data-preview-table">
                      <span className="table-header">Data Preview</span>
                      <Table
                        rowKey="index"
                        dataSource={epostabledataPreview}
                        className="custom-table"
                        columns={epostabledataPreviewColumns}
                        pagination={{ pageSize: 200 }}
                        scroll={{
                          x: epostabledataPreviewColumns.length * 250,
                          y: 400,
                        }}
                      />
                    </Row>
                  </Loader>

                  <Row style={{ marginTop: 10 }}>
                    <Col span={24}>
                      <div className="d-right">
                        <div
                          style={{ textAlign: "right", marginBottom: 10 }}
                        ></div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Loader>
            </Col>
          </Row>
        </Loader>
      </Content>
    </Wrapper>
  );
};

export default withRouter(EposPage);
